import { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const faqs = [
  {
    question: 'Was kostet ein Umzug von der Schweiz nach Deutschland?',
    answer: (navigate: any) => (
      <>
        Die Kosten hängen von mehreren Faktoren ab: <strong>Umzugsvolumen, Distanz, Stockwerk</strong> und gewünschte Zusatzleistungen. Ein <strong>2-Zimmer-Umzug beginnt bei ca. CHF 3'900.–</strong>, ein <strong>3-Zimmer-Umzug bei ca. CHF 5'900.–</strong> und ein <strong>4-Zimmer-Umzug bei ca. CHF 7'900.–</strong>. Nach einer <strong>kostenlosen Besichtigung</strong> erhalten Sie eine <strong>transparente Fixpreis-Offerte</strong>. <a href="/preise" onClick={(e) => { e.preventDefault(); navigate('/preise'); }} className="text-slate-800 underline hover:text-slate-600 font-semibold">Weitere Infos zu unseren Preisen</a>.
      </>
    ),
  },
  {
    question: 'Welche Zollformalitäten muss ich beachten?',
    answer: (navigate: any) => (
      <>
        Bei einem Umzug von der Schweiz nach Deutschland benötigen Sie: <strong>Wohnsitzbestätigung, Inventarliste des Umzugsguts</strong> und ggf. weitere Dokumente. <strong>Wir übernehmen die komplette Zollabwicklung für Sie</strong> und beraten Sie, welche Unterlagen erforderlich sind. <a href="/zollabwicklung" onClick={(e) => { e.preventDefault(); navigate('/zollabwicklung'); }} className="text-slate-800 underline hover:text-slate-600 font-semibold">Mehr zur Zollabwicklung</a>.
      </>
    ),
  },
  {
    question: 'Wie lange dauert ein Umzug Schweiz → Deutschland?',
    answer: (navigate: any) => (
      <>
        Die reine Transportzeit beträgt je nach Strecke <strong>3-8 Stunden</strong>. Der gesamte Umzug (Ein- und Ausladen, Möbelmontage) dauert in der Regel <strong>1-2 Tage</strong>. <a href="/express-umzuege" onClick={(e) => { e.preventDefault(); navigate('/express-umzuege'); }} className="text-slate-800 underline hover:text-slate-600 font-semibold">Express-Umzüge innerhalb von 24-48 Stunden</a> sind nach Absprache möglich.
      </>
    ),
  },
  {
    question: 'Kann ich auch nur Möbel transportieren lassen?',
    answer: (navigate: any) => (
      <>
        Ja, wir bieten auch <a href="/teilumzug" onClick={(e) => { e.preventDefault(); navigate('/teilumzug'); }} className="text-slate-800 underline hover:text-slate-600 font-semibold">Teilumzüge</a> an. Sie können entscheiden, ob Sie nur den Transport wünschen oder auch Services wie <strong>Verpackung, Montage oder Ein-/Auspackservice</strong> dazubuchen möchten.
      </>
    ),
  },
  {
    question: 'Bieten Sie Verpackungsmaterial an?',
    answer: (navigate: any) => (
      <>
        Ja, wir stellen <a href="/verpackungsmaterial" onClick={(e) => { e.preventDefault(); navigate('/verpackungsmaterial'); }} className="text-slate-800 underline hover:text-slate-600 font-semibold">professionelles Verpackungsmaterial</a> zur Verfügung: <strong>stabile Umzugskartons, Luftpolsterfolie, Packpapier, Möbeldecken</strong> und <strong>Spezialbehälter für empfindliche Gegenstände</strong>. Das Material kann Sie im Angebot einkalkulieren.
      </>
    ),
  },
  {
    question: 'Übernehmen Sie die Zollabwicklung?',
    answer: (navigate: any) => (
      <>
        Absolut! Die <strong>komplette <a href="/zollabwicklung" onClick={(e) => { e.preventDefault(); navigate('/zollabwicklung'); }} className="text-slate-800 underline hover:text-slate-600 font-semibold">Zollabwicklung ist bei uns im Service inbegriffen</a></strong>. Wir kennen alle Bestimmungen, erstellen die erforderlichen Dokumente und wickeln den Grenzübertritt für Sie ab – <strong>ohne dass Sie sich darum kümmern müssen</strong>.
      </>
    ),
  },
  {
    question: 'Welche Unterlagen brauche ich für den Zoll?',
    answer: (navigate: any) => (
      <>
        In der Regel benötigen Sie: <strong>Nachweis über Wohnsitzwechsel (Abmeldung Schweiz, Anmeldung Deutschland), detaillierte Inventarliste, Personalausweis/Pass</strong>. Wir beraten Sie individuell und helfen bei der Vorbereitung aller Dokumente. <a href="/ablauf" onClick={(e) => { e.preventDefault(); navigate('/ablauf'); }} className="text-slate-800 underline hover:text-slate-600 font-semibold">Mehr zum Ablauf</a>.
      </>
    ),
  },
  {
    question: 'Kann ich auch kurzfristig einen Umzug buchen?',
    answer: (navigate: any) => (
      <>
        Ja, wir versuchen auch <strong>kurzfristige Umzüge</strong> zu ermöglichen. <a href="/express-umzuege" onClick={(e) => { e.preventDefault(); navigate('/express-umzuege'); }} className="text-slate-800 underline hover:text-slate-600 font-semibold">Express-Umzüge sind oft innerhalb von 24-48 Stunden realisierbar</a>. Je früher Sie uns kontaktieren, desto besser können wir Ihren Wunschtermin berücksichtigen.
      </>
    ),
  },
  {
    question: 'Führen Sie auch Firmenumzüge Schweiz → Deutschland durch?',
    answer: (navigate: any) => (
      <>
        Ja, wir sind spezialisiert auf <a href="/firmenumzuege" onClick={(e) => { e.preventDefault(); navigate('/firmenumzuege'); }} className="text-slate-800 underline hover:text-slate-600 font-semibold">Firmenumzüge und Büroumzüge</a>. Wir bieten <strong>Wochenend- und Nachtumzüge</strong> an, damit Ihr Geschäftsbetrieb nicht unterbrochen wird. Auf Wunsch übernehmen wir auch <strong>IT-Equipment-Transport und Büromöbelmontage</strong>.
      </>
    ),
  },
  {
    question: 'Gibt es Zwischenlagerungen in der Schweiz oder Deutschland?',
    answer: (navigate: any) => (
      <>
        Ja, wir bieten <a href="/zwischenlagerung" onClick={(e) => { e.preventDefault(); navigate('/zwischenlagerung'); }} className="text-slate-800 underline hover:text-slate-600 font-semibold">sichere Zwischenlagerung</a> sowohl in der Schweiz als auch in Deutschland an. Ihre Möbel werden in <strong>trockenen, bewachten Lagerhallen</strong> aufbewahrt – <strong>flexibel für Tage, Wochen oder Monate</strong>.
      </>
    ),
  },
  {
    question: 'Bieten Sie auch Endreinigung in der alten Wohnung an?',
    answer: (navigate: any) => (
      <>
        Ja, wir bieten <a href="/endreinigung" onClick={(e) => { e.preventDefault(); navigate('/endreinigung'); }} className="text-slate-800 underline hover:text-slate-600 font-semibold">professionelle Endreinigung als Zusatzservice</a> an. So können Sie sicher sein, dass Ihre alte Wohnung <strong>besenrein oder sogar abnahmefertig</strong> übergeben wird.
      </>
    ),
  },
  {
    question: 'Sind meine Möbel versichert?',
    answer: (navigate: any) => (
      <>
        Ja, <strong>alle Transporte sind grundversichert</strong>. Auf Wunsch bieten wir <strong>erweiterten Versicherungsschutz</strong> für hochwertige oder besonders empfindliche Gegenstände (Kunst, Antiquitäten, etc.) an. <a href="/leistungen" onClick={(e) => { e.preventDefault(); navigate('/leistungen'); }} className="text-slate-800 underline hover:text-slate-600 font-semibold">Mehr zu unseren Leistungen</a>.
      </>
    ),
  },
  {
    question: 'Kann ich beim Umzug selbst mithelfen, um Kosten zu sparen?',
    answer: (navigate: any) => (
      <>
        Grundsätzlich ja – Sie können z.B. selbst Kartons packen oder kleine Gegenstände transportieren. Aus <strong>versicherungstechnischen und haftungsrechtlichen Gründen</strong> führen wir den <strong>Haupttransport und die Möbelmontage</strong> jedoch selbst durch. Informieren Sie sich über unseren <a href="/teilumzug" onClick={(e) => { e.preventDefault(); navigate('/teilumzug'); }} className="text-slate-800 underline hover:text-slate-600 font-semibold">Teilumzug-Service</a>.
      </>
    ),
  },
  {
    question: 'Transportieren Sie auch heikle Güter (Klavier, Kunst, Maschinen)?',
    answer: (navigate: any) => (
      <>
        Ja, wir haben Erfahrung mit <strong>Spezialtransporten: Klaviere, Flügel, Tresore, Kunstwerke, Maschinen</strong> und andere schwere oder empfindliche Gegenstände. Diese werden mit <strong>Spezialequipment und besonderer Sorgfalt</strong> transportiert. Kontaktieren Sie uns für eine <a href="/offerte-anfordern" onClick={(e) => { e.preventDefault(); navigate('/offerte-anfordern'); }} className="text-slate-800 underline hover:text-slate-600 font-semibold">individuelle Offerte</a>.
      </>
    ),
  },
  {
    question: 'Welche Regionen in Deutschland decken Sie ab?',
    answer: (navigate: any) => (
      <>
        Wir decken <strong>ganz Deutschland</strong> ab – von <strong>München über Berlin, Hamburg, Stuttgart, Frankfurt bis Köln</strong> und alle anderen Städte und Regionen. Besonders häufig führen wir Umzüge aus <a href="/umzug-zuerich-deutschland" onClick={(e) => { e.preventDefault(); navigate('/umzug-zuerich-deutschland'); }} className="text-slate-800 underline hover:text-slate-600 font-semibold">Zürich</a>, <a href="/umzug-basel-deutschland" onClick={(e) => { e.preventDefault(); navigate('/umzug-basel-deutschland'); }} className="text-slate-800 underline hover:text-slate-600 font-semibold">Basel</a> und <a href="/umzug-bern-deutschland" onClick={(e) => { e.preventDefault(); navigate('/umzug-bern-deutschland'); }} className="text-slate-800 underline hover:text-slate-600 font-semibold">Bern</a> nach Deutschland durch.
      </>
    ),
  },
  {
    question: 'Haben Sie Erfahrung mit Grenzumzügen?',
    answer: (navigate: any) => (
      <>
        Ja, wir sind <strong>spezialisiert auf internationale Umzüge</strong> zwischen der Schweiz und Deutschland. Mit <strong>über 10 Jahren Erfahrung und mehr als 500 Grenzumzügen pro Jahr</strong> kennen wir alle Besonderheiten und <a href="/zollabwicklung" onClick={(e) => { e.preventDefault(); navigate('/zollabwicklung'); }} className="text-slate-800 underline hover:text-slate-600 font-semibold">Zollbestimmungen</a>.
      </>
    ),
  },
  {
    question: 'Gibt es einen Festpreis oder Stundenansatz?',
    answer: (navigate: any) => (
      <>
        Wir bieten beides an: Nach einer Besichtigung erstellen wir Ihnen eine <strong>Fixpreis-Offerte, die alle Leistungen transparent auflistet</strong>. Auf Wunsch ist auch eine <strong>Abrechnung nach Stunden</strong> möglich – Sie entscheiden, was Ihnen lieber ist. <a href="/preise" onClick={(e) => { e.preventDefault(); navigate('/preise'); }} className="text-slate-800 underline hover:text-slate-600 font-semibold">Details zu unseren Preismodellen</a>.
      </>
    ),
  },
  {
    question: 'Muss ich beim Zoll anwesend sein?',
    answer: (navigate: any) => (
      <>
        <strong>In der Regel nein.</strong> Wir wickeln die <a href="/zollabwicklung" onClick={(e) => { e.preventDefault(); navigate('/zollabwicklung'); }} className="text-slate-800 underline hover:text-slate-600 font-semibold">Zollformalitäten</a> für Sie ab. In seltenen Fällen kann die Zollbehörde zusätzliche Nachweise verlangen – wir informieren Sie rechtzeitig, falls Ihre Anwesenheit erforderlich ist.
      </>
    ),
  },
  {
    question: 'Übernehmen Sie die Möbelmontage am Zielort?',
    answer: (navigate: any) => (
      <>
        Ja, die <strong>Möbelmontage und -demontage ist bei den meisten unserer Pakete inklusive</strong>. Wir bauen Ihre Möbel fachgerecht ab, transportieren sie sicher und montieren sie am Zielort wieder – <strong>genau dort, wo Sie es wünschen</strong>. Mehr dazu bei unserem <a href="/komplettumzug" onClick={(e) => { e.preventDefault(); navigate('/komplettumzug'); }} className="text-slate-800 underline hover:text-slate-600 font-semibold">Komplettumzug-Service</a>.
      </>
    ),
  },
  {
    question: 'Was muss ich beim Auswandern nach Deutschland beachten?',
    answer: (navigate: any) => (
      <>
        Beim <strong>Auswandern nach Deutschland</strong> sollten Sie folgendes beachten: <strong>Abmeldung in der Schweiz, Anmeldung in Deutschland (innerhalb 14 Tage), Zolldokumente vorbereiten, Krankenversicherung wechseln, Arbeitsvertrag prüfen</strong>. Als erfahrene <strong>Umzugsfirma nach Deutschland</strong> unterstützen wir Sie bei der <a href="/ablauf" onClick={(e) => { e.preventDefault(); navigate('/ablauf'); }} className="text-slate-800 underline hover:text-slate-600 font-semibold">Umzugsplanung</a> und <a href="/zollabwicklung" onClick={(e) => { e.preventDefault(); navigate('/zollabwicklung'); }} className="text-slate-800 underline hover:text-slate-600 font-semibold">Zollabwicklung</a>.
      </>
    ),
  },
  {
    question: 'Welche Umzugsfirma ist am besten für Umzug nach Deutschland?',
    answer: (navigate: any) => (
      <>
        Eine gute <strong>Umzugsfirma nach Deutschland</strong> sollte: <strong>Erfahrung mit internationalen Umzügen, vollständige <a href="/zollabwicklung" onClick={(e) => { e.preventDefault(); navigate('/zollabwicklung'); }} className="text-slate-800 underline hover:text-slate-600 font-semibold">Zollabwicklung</a>, Fixpreis-Garantie, Versicherungsschutz</strong> und transparente Preise bieten. Wir sind spezialisiert auf <strong>Umzug Schweiz Deutschland</strong> mit über <strong>2000 erfolgreichen Umzügen nach Deutschland</strong>. <a href="/leistungen" onClick={(e) => { e.preventDefault(); navigate('/leistungen'); }} className="text-slate-800 underline hover:text-slate-600 font-semibold">Entdecken Sie unsere Leistungen</a>.
      </>
    ),
  },
  {
    question: 'Wie viel kostet eine Umzugsfirma nach Deutschland?',
    answer: (navigate: any) => (
      <>
        Die Kosten für eine professionelle <strong>Umzugsfirma nach Deutschland</strong> beginnen ab <strong>CHF 3\'900 für 2 Zimmer</strong>. Der Preis hängt von <strong>Wohnungsgröße, Distanz, Stockwerk und Services</strong> ab. Wir erstellen Ihnen nach einer <strong>kostenlosen Besichtigung eine transparente Fixpreis-Offerte</strong> für Ihren <strong>Umzug Schweiz Deutschland</strong>. <a href="/preise" onClick={(e) => { e.preventDefault(); navigate('/preise'); }} className="text-slate-800 underline hover:text-slate-600 font-semibold">Alle Preise im Überblick</a>.
      </>
    ),
  },
  {
    question: 'Wie lange dauert Auswandern nach Deutschland?',
    answer: (navigate: any) => (
      <>
        Der physische <strong>Umzug nach Deutschland</strong> dauert <strong>1-2 Tage</strong>. Die gesamte Auswanderungsplanung mit <strong>Behördengängen, Zollanmeldung, Wohnungssuche</strong> sollten Sie <strong>2-3 Monate im Voraus</strong> beginnen. Als <strong>Umzugsfirma nach Deutschland</strong> koordinieren wir den Umzugsteil professionell für Sie. <a href="/ablauf" onClick={(e) => { e.preventDefault(); navigate('/ablauf'); }} className="text-slate-800 underline hover:text-slate-600 font-semibold">Mehr zum Ablauf</a>.
      </>
    ),
  },
  {
    question: 'Gibt es einen kostenlosen Besichtigungstermin?',
    answer: (navigate: any) => (
      <>
        Ja, die <strong>Besichtigung ist bei uns immer kostenlos und unverbindlich</strong>. Wir kommen zu Ihnen nach Hause oder führen eine <a href="/sofort-besichtigung" onClick={(e) => { e.preventDefault(); navigate('/sofort-besichtigung'); }} className="text-slate-800 underline hover:text-slate-600 font-semibold">Video-Besichtigung</a> durch, erfassen das Umzugsvolumen und erstellen Ihnen anschließend eine <strong>transparente Offerte</strong>. <a href="/offerte-anfordern" onClick={(e) => { e.preventDefault(); navigate('/offerte-anfordern'); }} className="text-slate-800 underline hover:text-slate-600 font-semibold">Jetzt Termin vereinbaren</a>.
      </>
    ),
  },
];

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const navigate = useNavigate();

  return (
    <section id="faq" className="py-20 bg-slate-50 relative overflow-hidden">
      <div className="absolute inset-0 opacity-5">
        <img
          src="/grenduebergang-schweiz-deutschland.jpeg"
          alt="Grenzübergang Schweiz Deutschland"
          className="w-full h-full object-cover"
        />
      </div>
      <div className="relative z-10 container mx-auto px-4">
        <div className="text-center mb-16">
          <div className="inline-block bg-slate-800 text-white px-4 py-2 rounded-full text-sm font-semibold mb-4">
            FAQ - Umzug nach Deutschland
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4">
            Umzug nach Deutschland: Alle wichtigen Fragen
          </h2>
          <p className="text-xl text-slate-600 max-w-2xl mx-auto">
            Antworten auf die wichtigsten Fragen zu Umzug Schweiz Deutschland, Auswandern nach Deutschland und Umzugsfirma nach Deutschland.
          </p>
        </div>

        <div className="max-w-4xl mx-auto">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="mb-4 bg-white rounded-xl border-2 border-slate-100 overflow-hidden transition hover:border-slate-300"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full px-6 py-5 flex items-center justify-between text-left transition"
              >
                <span className="font-semibold text-slate-900 text-lg pr-4">
                  {faq.question}
                </span>
                <ChevronDown
                  className={`w-5 h-5 text-slate-600 flex-shrink-0 transition-transform ${
                    openIndex === index ? 'rotate-180' : ''
                  }`}
                />
              </button>
              {openIndex === index && (
                <div className="px-6 pb-5 text-slate-600 leading-relaxed [&_strong]:text-slate-900 [&_strong]:font-semibold [&_a]:transition-colors">
                  {typeof faq.answer === 'function' ? faq.answer(navigate) : faq.answer}
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <p className="text-slate-600 mb-6">
            Haben Sie weitere Fragen? Kontaktieren Sie uns – wir helfen Ihnen gerne weiter!
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center space-y-4 sm:space-y-0 sm:space-x-4">
            <a
              href="tel:0800700100"
              className="bg-slate-800 hover:bg-slate-900 text-white px-8 py-3 rounded-lg font-semibold transition shadow-md hover:shadow-lg"
            >
              0800 700 100 (Gratis)
            </a>
            <button
              onClick={() => {
                const element = document.getElementById('kontakt');
                if (element) element.scrollIntoView({ behavior: 'smooth' });
              }}
              className="bg-white hover:bg-slate-50 text-slate-800 px-8 py-3 rounded-lg font-semibold transition shadow-md hover:shadow-lg border-2 border-slate-200"
            >
              Nachricht senden
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
